import NonEditorMenu from './NonEditorMenu';

export default NonEditorMenu;
